import clsx from 'clsx';
import { ReactNode, useState } from 'react';

interface Props {
  label: ReactNode;
  dropdown: ReactNode;
}

const NavigationItem = (props: Props) => {
  const { label, dropdown } = props;
  const [expanded, setExpanded] = useState(false);

  return (
    <>
      <div
        className={clsx(
          'flex items-center justify-between px-[15px] py-[18px] text-base',
          'border-b-1 border-solid border-E7DED5',
        )}
        onClick={() => {
          setExpanded(x => !x);
        }}
      >
        <div className='text-[17px] leading-6 text-#403732'>{label}</div>
        <span
          className={clsx(
            ' relative h-3 w-3 ',
            'before_content-[""] after_content-[""]',
            'before_h-0.5 before_w-full after_h-0.5 after_w-full',
            'before_bg-80583F',
            'before_absolute before_left-1/2 before_top-1/2 before_-translate-x-1/2 before_-translate-y-1/2',
            'after_absolute after_left-1/2 after_top-1/2 after_-translate-x-1/2 after_-translate-y-1/2',
            'after_rotate-90',
            expanded ? 'after_bg-transparent' : 'after_bg-80583F',
          )}
        />
      </div>
      <div className={expanded ? '' : 'hidden'}>{dropdown}</div>
    </>
  );
};

export default NavigationItem;
